var _rect, _defs, _defs2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 512 512",
    style: {
      overflow: "visible"
    },
    "data-bbox": "24.321311210489498 69.42234198341517 487.6786887895105 434.0770692244369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-uid": "o_faja1e2j7_14",
    "data-fl-background": "",
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "transparent"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_faja1e2j7_15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.15%",
    y1: "24.27%",
    x2: "92.85%",
    y2: "75.73%",
    id: "o_faja1e2j7_9",
    gradientUnits: "objectBoundingBox",
    "data-uid": "o_faja1e2j7_28"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(165, 254, 203)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    stopColor: "rgb(32,200,255)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97%",
    stopColor: "rgb(9,54,240)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.15%",
    y1: "24.27%",
    x2: "92.85%",
    y2: "75.73%",
    id: "o_faja1e2j7_11",
    gradientUnits: "objectBoundingBox",
    "data-uid": "o_faja1e2j7_36"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(165, 254, 203)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "9%",
    stopColor: "rgb(32,200,255)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97%",
    stopColor: "rgb(9,54,240)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.15%",
    y1: "24.27%",
    x2: "92.85%",
    y2: "75.73%",
    id: "g_-1369531890_1",
    gradientUnits: "objectBoundingBox",
    "data-uid": "o_faja1e2j7_66"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(165, 254, 203)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59%",
    stopColor: "rgb(32, 189, 255)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(138, 9, 240)",
    stopOpacity: 1,
    "data-uid": "o_faja1e2j7_69"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    "data-uid": "o_faja1e2j7_44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9337395218850297, 0, 0, 1.9337395218850297, -110.49261639617181, -70.04377288056263)",
    "data-uid": "o_faja1e2j7_51",
    fill: "url(#g_-1369531890_1)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    enableBackground: "new 0 0 360 360",
    width: 360,
    height: 360,
    "data-uid": "o_faja1e2j7_52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2103_",
    className: "st0",
    d: "M70.41 192.23l0.14-0.06c9.38-3.89 20.37 0.18 24.52 9.46c4.3 9.63-0.21 20.84-9.89 24.85 l-0.36 0.15c-3.83 1.58-5.18 6.32-2.77 9.7c2.58 3.61 5.33 7.05 8.25 10.31l0 0l40.84-40.84c-8.57-10.6-13.71-24.1-13.71-38.79 c0-34.1 27.65-61.75 61.75-61.75c14.7 0 28.19 5.14 38.79 13.71l40.83-40.83v0l39.22-39.22c0 0-62.35 53.5-83.85 44.13 c-9.67-4.21-14.59-14.89-10.58-24.56l0.14-0.35c1.58-3.82-0.8-8.13-4.88-8.81c-13.02-2.19-26.49-2.24-39.89 0.07 c-4.14 0.72-6.56 5.1-4.95 8.98c0.99 2.4 1.47 4.91 1.47 7.39c0 6.89-3.69 13.52-10.16 16.76c-9.8 4.9-21.5 0.41-25.62-9.52 c-1.1-2.65-3.64-4.17-6.25-4.17c-1.35 0-2.72 0.4-3.91 1.26C98.6 77.95 89.26 87.48 81.72 98.17c-2.41 3.43-1.02 8.21 2.85 9.82 c7.24 3 11.86 10.04 11.86 17.5c0 1.9-0.3 3.83-0.93 5.72c-3.46 10.39-14.91 15.49-24.85 11.38l-0.35-0.14 c-3.82-1.58-8.13 0.8-8.81 4.88c-2.2 13.06-2.24 26.59 0.1 40.04C62.31 191.44 66.59 193.81 70.41 192.23z",
    fill: "url(#g_-1369531890_1)",
    "data-uid": "o_faja1e2j7_53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2102_",
    className: "st1",
    d: "M287.95 141.78l-0.14 0.06c-9.38 3.89-20.37-0.18-24.52-9.46c-4.3-9.63 0.21-20.84 9.89-24.85 l0.36-0.15c3.83-1.58 5.18-6.32 2.77-9.7c-2.58-3.61-5.33-7.05-8.25-10.31l0 0l-40.84 40.84c8.57 10.6 13.71 24.1 13.71 38.79 c0 34.1-27.65 61.75-61.75 61.75c-14.7 0-28.19-5.14-38.79-13.71l-40.83 40.83v0L60.34 295.1c0 0 62.35-53.5 83.85-44.13 c9.67 4.21 14.59 14.89 10.58 24.56l-0.14 0.35c-1.58 3.82 0.8 8.13 4.88 8.81c13.02 2.19 26.49 2.24 39.89-0.07 c4.14-0.72 6.56-5.1 4.95-8.98c-0.99-2.4-1.47-4.91-1.47-7.39c0-6.89 3.69-13.52 10.16-16.76c9.8-4.9 21.5-0.41 25.62 9.52 c1.1 2.65 3.64 4.17 6.25 4.17c1.35 0 2.72-0.4 3.91-1.26c10.94-7.85 20.28-17.37 27.82-28.07c2.41-3.43 1.02-8.21-2.85-9.82 c-7.24-3-11.86-10.04-11.86-17.5c0-1.9 0.3-3.83 0.93-5.72c3.46-10.39 14.91-15.49 24.85-11.38l0.35 0.14 c3.82 1.58 8.13-0.8 8.81-4.88c2.2-13.06 2.24-26.59-0.1-40.04C296.05 142.57 291.77 140.2 287.95 141.78z",
    fill: "url(#g_-1369531890_1)",
    "data-uid": "o_faja1e2j7_54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.ff862d6fdb3df5eec616719b74510ee4.svg";
export { ForwardRef as ReactComponent };